// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetSubscriptionsListRequest,
  TGetSubscriptionsListModel,
  IMappers,
  TGetSubscriptionsListResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IResponseSchema } from '../../entities/entities/ResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetSubscriptionsListModel(parameters: IGetSubscriptionsListRequest): TGetSubscriptionsListModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'subscriptions',
    pathApi: '/v1/get-subscriptions-list/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetSubscriptionsListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetSubscriptionsListRequest;
}

export async function fetchGetSubscriptionsList<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetSubscriptionsListOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetSubscriptionsListResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetSubscriptionsListModel(parameters),
    config,
  )) as FetchResponse<TGetSubscriptionsListResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetSubscriptionsListResponse>;
}
